module.exports = __webpack_public_path__ + "img/nerys_horizontal.8e183267.svg";